// Size filter: one entry per letter. Ticking "S" ticks every size under it (36, 38, Small);
// capture phase so the theme's own change/click handlers see the synced state.
document.addEventListener(
  'change',
  (event) => {
    const item = event.target.closest?.('li[data-nk-size]');
    if (!item) return;
    for (const li of item.parentElement.children) {
      if (li.dataset.nkSize !== item.dataset.nkSize) continue;
      const input = li.querySelector('input[type="checkbox"]');
      if (input) input.checked = event.target.checked;
    }
  },
  true
);

// A size chip removes every size under its letter, not only the first one.
const nkGroupChipUrl = (event) => {
  const chip = event.target.closest?.('[data-nk-values]');
  if (!chip) return;
  const values = chip.dataset.nkValues.split('|').filter(Boolean);
  const url = new URL(location.href);
  const kept = [...url.searchParams].filter(([key, value]) => !(key === chip.dataset.nkParam && values.includes(value)));
  chip.dataset.url = `${url.pathname}?${new URLSearchParams(kept)}`;
};
document.addEventListener('click', nkGroupChipUrl, true);
document.addEventListener('keydown', nkGroupChipUrl, true);

// Product page, phone: the pinned buy bar shows from load (CSS in nakhle.css) and steps aside while the page's own
// Add to bag is on screen; this class is the only signal the CSS needs.
(function () {
  var block = document.querySelector('.product-details .buy-buttons-block');
  if (!block || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (entries) {
    document.documentElement.classList.toggle('nk-buy-in-view', entries[0].isIntersecting);
  }).observe(block);
})();

// Hero film (snippets/nakhle-hero-video.liquid): once the page has painted, load only the film this screen shows.
// ponytail: decided once at load; turning a tablet across 750px keeps the still, a reload fixes it.
window.addEventListener('load', function () {
  document.querySelectorAll('video[data-nk-video]').forEach(function (video) {
    if (!video.offsetParent) return;
    video.src = video.dataset.nkVideo;
    video.play().catch(function () {});
  });
});

/* Product page WhatsApp: the message carries the colour and size she picked, so a sold-out size can be asked about
   (critique 2026-10-04). The link is built once by Liquid; the theme redraws only the picker on a change. */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('.product-details a.nakhle-whatsapp');
  if (!a) return;
  var picked = Array.prototype.map.call(
    a.closest('.product-details').querySelectorAll('variant-picker input:checked'),
    function (i) { return (i.closest('label') || i.parentElement).textContent.replace(/\s+/g, ' ').trim(); }
  ).join(' / ');
  var url = new URL(a.href);
  if (!a.dataset.nkText) a.dataset.nkText = url.searchParams.get('text') || '';
  url.searchParams.set('text', picked ? a.dataset.nkText + '\n' + picked : a.dataset.nkText);
  a.href = url.toString();
});

/* Product page, desktop (Ed 2026-10-07, reference: retrofete.com) */

// "Size guide" (beside the size label, and in the Size & fit row) opens the size guide pop-up (Ed 2026-10-08).
// Esc closes it natively; the close button and a click on the dimmed page close it here.
document.addEventListener('click', function (e) {
  var dialog = document.querySelector('.nk-sg');
  if (!dialog || !e.target.closest) return;
  if (e.target.closest('a[href="#size-guide"]')) {
    e.preventDefault();
    dialog.showModal();
  } else if (e.target === dialog || e.target.closest('.nk-sg__close')) {
    dialog.close();
  }
});

// "Explore more": two tabs over the recommendations, Similar styles (the theme's related pieces) and Recently viewed
// (the ids the theme keeps in localStorage, drawn by sections/nakhle-recently-viewed.liquid). No other viewed pieces, no tab.
(function () {
  var section = document.querySelector('product-recommendations[data-product-id]');
  if (!section || !window.matchMedia('(min-width: 750px)').matches) return;
  var current = section.dataset.productId;
  var ids = [];
  try { ids = JSON.parse(localStorage.getItem('viewedProducts') || '[]'); } catch (err) {}
  ids = ids.filter(function (id) { return String(id) !== String(current); });
  if (!section.querySelector('.section-resource-list__content')) return;

  var tabs = document.createElement('div');
  tabs.className = 'nk-tabs';
  tabs.setAttribute('role', 'tablist');
  tabs.innerHTML = '<button type="button" role="tab" aria-selected="true" data-nk-tab="similar">Similar styles</button>' +
    (ids.length ? '<button type="button" role="tab" aria-selected="false" data-nk-tab="recent">Recently viewed</button>' : '');
  var panel = document.createElement('div');
  panel.className = 'nk-rv';
  panel.hidden = true;
  var loaded = false;
  // the theme morphs this section when its recommendations arrive, which can drop added nodes: put them back
  function place() {
    var content = section.querySelector('.section-resource-list__content');
    if (!content) return;
    if (!tabs.isConnected) content.appendChild(tabs);
    if (!panel.isConnected) content.parentElement.appendChild(panel);
  }
  place();
  new MutationObserver(place).observe(section, { childList: true, subtree: true });

  tabs.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nk-tab]');
    if (!btn) return;
    var recent = btn.dataset.nkTab === 'recent';
    tabs.querySelectorAll('[data-nk-tab]').forEach(function (b) { b.setAttribute('aria-selected', String(b === btn)); });
    section.classList.toggle('nk-show-recent', recent);
    panel.hidden = !recent;
    if (!recent || loaded) return;
    loaded = true;
    var url = '/search?section_id=nakhle-recently-viewed&type=product&q=' +
      encodeURIComponent(ids.map(function (id) { return 'id:' + id; }).join(' OR '));
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = doc.querySelector('.nk-rv__grid');
      if (grid) panel.appendChild(grid);
    });
  });
})();

/* Complete the look: the Add to bag button wakes up once a size is picked (Ed 2026-10-08) */
document.addEventListener('change', function (e) {
  if (!e.target.matches('.nk-look__select')) return;
  var btn = e.target.form && e.target.form.querySelector('.nk-look__add');
  if (btn) btn.disabled = !e.target.value;
});
